import { getAuth } from 'firebase/auth';

const BASE = import.meta.env.VITE_API_URL;

async function authHeaders(): Promise<HeadersInit> {
  const user = getAuth().currentUser;
  if (!user) throw new Error('Not authenticated');
  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
}

export const dealApprovalApi = {
  sendForApproval: async (dealId: string) => {
    const res = await fetch(`${BASE}/deals/${dealId}/send-for-approval`, {
      method: 'POST',
      headers: await authHeaders(),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },

  sellerApprove: async (dealId: string) => {
    const res = await fetch(`${BASE}/deals/${dealId}/seller-approve`, {
      method: 'POST',
      headers: await authHeaders(),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },

  sellerReject: async (dealId: string, reason: string) => {
    const res = await fetch(`${BASE}/deals/${dealId}/seller-reject`, {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify({ reason }),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },

  getApprovalStatus: async (dealId: string) => {
    const res = await fetch(`${BASE}/deals/${dealId}/approval-status`, {
      headers: await authHeaders(),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  },
};